import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

export const products = (): void => {
  console.log("products");
  const productImages = document.querySelectorAll(".c-list-card__img");
  const productImageBtns = document.querySelectorAll(".c-list-card__actions .c-btn-round button");
  productImageBtns.forEach((imageBtn) => {
    imageBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const btnLabel = imageBtn.getAttribute("data-image");
      const targetImage = document.querySelector(`.c-list-card__img[data-image="${btnLabel}"]`);
      productImages.forEach((image) => {
        const imageLabel = image.getAttribute("data-image");
        image.classList.remove("--active");
        if (imageLabel === btnLabel) {
          image.classList.add("--active");
        }
      });
      productImageBtns.forEach((btn) => {
        btn.classList.remove("--active");
        if (btn.getAttribute("data-image") === btnLabel) {
          btn.classList.add("--active");
        }
      });
    });
  });
  gsap.utils.toArray(".c-subpage-ttl").forEach((group) => {
    const groupElement = group as Element;
    const splitText = new SplitText(groupElement, { types: "chars", tag: "span" });
    gsap.set(splitText.chars, {
      display: "inline-block",
    });
    gsap.from(splitText.chars, {
      opacity: 0,
      rotation: -10,
      duration: 0.7,
      stagger: 0.1,
    });
  });
};
